import { ReqBodyType } from './types/reqBody';
import HttpClient from './utils/HttpClient';

interface AuthServiceInterface {
  token: string;
  reqBody?: ReqBodyType;
  codUsu?: string;
  perfilUsu?: string;
  codAcesso?: string;
  cpf?: string;
}

class AuthService {
  private readonly httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient(process.env.REACT_APP_PATHNAME ?? '');
  }

  getValidationTk = async () => {
    return this.httpClient.post({
      token: '',
      path: '/api/SMob_TK0',
      reqBody: JSON.stringify({
        apiCode: process.env.REACT_APP_API_CODE,
        key: process.env.REACT_APP_API_KEY,
      }),
    });
  };

  loginWithUsername = async ({
    token,
    reqBody,
  }: AuthServiceInterface) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_Acesso2022',
      reqBody,
    });
  };

  login = async ({
    token,
    reqBody,
  }: AuthServiceInterface) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_AcessoEntrar',
      reqBody,
    });
  };

  directLogin = async ({
    token,
  }: AuthServiceInterface) => {
    return this.httpClient.get({
      token,
      path: '/api/SMob_AcessoEntrar',
    });
  };

  signup = async ({
    token,
    reqBody,
  }: AuthServiceInterface) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_AcessoPrimeiro',
      reqBody,
    });
  };

  createCompany = async ({
    token,
    reqBody,
  }: AuthServiceInterface) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_CadCliEmpresa',
      reqBody,
    });
  };

  validateRegister = async ({
    token,
    codUsu,
    perfilUsu,
    codAcesso,
  }: AuthServiceInterface) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_AcessoPrimeiro?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codAcesso=${codAcesso}`,
    });
  };

  resendAccessCode = async ({
    token,
    codUsu,
    perfilUsu,
  }: AuthServiceInterface) => {
    return this.httpClient.put({
      token,
      path: `/api/SMob_AcessoPrimeiro?codUsu=${codUsu}&perfilUsu=${perfilUsu}`,
    });
  };

  getTk = async ({
    reqBody,
  }: AuthServiceInterface) => {
    return this.httpClient.post({
      path: '/api/SMob_TK',
      reqBody,
      token: '',
    });
  };

  validaAcesso = async ({
    reqBody,
    token,
  }: AuthServiceInterface) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_ValidaAcesso',
      reqBody,
    });
  };

  sendValidateCode = async ({
    token,
    cpf,
  }: AuthServiceInterface) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_AcessoTrocaSenha?cpf=${cpf}`,
    });
  };

  changePassword = async ({
    token,
    reqBody,
  }: AuthServiceInterface) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_AcessoTrocaSenha',
      reqBody,
    });
  };

  changePasswordLogged = async ({
    token,
    reqBody,
  }: AuthServiceInterface) => {
    return this.httpClient.put({
      token,
      path: '/api/SMob_AcessoTrocaSenha',
      reqBody,
    });
  };
}

export default new AuthService();
